export default {
  get({ values }) {
    return [200, { data: {}, links: {} }]
  },
}
